<div class="auth-main">
  <div class="auth-wrapper version-2 confirm">
    <!-- <div class="auth-side-content">
      <div
        style="background-image: url(&quot;assets/images/hotel.jpg&quot;)"
        alt="images"
        class="img-fluid img-auth-side"
      ></div>
    </div> -->
    <div class="auth-form">
      <app-card [showHeader]="false" class="auth-form-card" padding="40">
        <div class="steps__wrapper">
          <div class="step" [ngClass]="{ active: state === 'Go' }">1</div>
          <div
            class="step"
            [ngClass]="{
              active:
                state === 'specifyByPhone' ||
                state === 'specifyByRoom' ||
                state === 'specifyByRoomAfterFull' ||
                state === 'bookedId' ||
                state === 'byName' ||
                state === 'byPhone' ||
                state === 'bookedIdConfirm'
            }"
          >
            2
          </div>
          <div class="step" [ngClass]="{ active: state === 'bookedConfirmed' }">3</div>
        </div>
        <h3
          i18n="@@t-1"
          *ngIf="state !== 'bookedConfirmed'"
          class="text-center m-b-25 m-t-25 f-w-500"
        >
          Подтверждение бронирования
        </h3>
        <h3
          i18n="@@t-2"
          *ngIf="state === 'bookedConfirmed'"
          class="text-center m-b-25 m-t-25 f-w-500"
        >
          Спасибо, {{ FirstName }}
        </h3>
        <div
          [ngClass]="{
            'state-initial': state === 'Go',
            'state-booked-confirmed': state === 'bookedConfirmed',
            'state-booked-id':
              state === 'byName' ||
              state === 'byPhone' ||
              state === 'bookedId' ||
              state === 'specifyByPhone' ||
              state === 'specifyByRoom' ||
              state === 'specifyByRoomAfterFull' ||
              state === 'bookedIdConfirm'
          }"
        >
          <div *ngIf="state === 'Go'">
            <div i18n="@@t-3" class="subtitle">
              Чтобы подтвердить бронирование, вам необходимо выбрать один из способов подтверждения
              по номеру ID бронирования, поля Фамилии и Имени или номеру телефона.&#013;
            </div>
            <div class="confirm-method methods__wrapper">
              <button
                i18n="@@t-4"
                mat-raised-button
                color="primary"
                class="b-rad-16"
                (click)="setBookedIdState('bookedId')"
              >
                ID бронирования
              </button>
              <button
                (click)="setBookedIdState('byName')"
                i18n="@@t-5"
                mat-raised-button
                color="primary"
                class="b-rad-16"
              >
                Фамилия и Имя
              </button>
              <button
                (click)="setBookedIdState('byPhone')"
                i18n="@@t-6"
                mat-raised-button
                color="primary"
                class="b-rad-16"
              >
                Номер телефона
              </button>
            </div>
          </div>

          <div *ngIf="state === 'bookedId'">
            <div i18n="@@t-7" class="subtitle">
              Чтобы подтвердить бронирование, вам необходимо ввести номер ID бронирования и
              следовать информации на экране.
            </div>
            <!-- <label for="name" class="f-w-500">Enter Your ID</label> -->
            <div class="confirm-method inputs__wrapper">
              <button i18n="@@t-8" mat-button color="primary" class="b-rad-16" (click)="back()">
                ‹ Вернуться
              </button>
              <mat-form-field appearance="outline" class="w-100 custom-input">
                <input
                  i18n-placeholder="@@t-27"
                  placeholder="ID бронирования"
                  matInput
                  [formControl]="bookedId"
                  required
                  [(ngModel)]="BookedId"
                />
                <mat-error i18n="@@t-9" *ngIf="bookedId.errors?.['required']"
                  >Book ID обязателен</mat-error
                >
                <mat-error i18n="@@t-10" *ngIf="bookedId.errors?.['minlength']"
                  >Book ID должен иметь минимум 3 символа</mat-error
                >
                <mat-error i18n="@@t-11" *ngIf="bookedId.errors?.['incorrect']">
                  Указан неверный Номер ID бронирования. Попробуйте ввести корректный номер
                </mat-error>
              </mat-form-field>
              <div *ngIf="loading" class="spinner__wrapper">
                <mat-spinner [diameter]="48"></mat-spinner>
              </div>
            </div>
            <span class="error-text" *ngIf="errors.init">
              {{ errors.init }}
            </span>
            <button
              i18n="@@t-12"
              *ngIf="bookedId.errors?.['required'] || bookedId.errors?.['minlength']"
              mat-raised-button
              disabled
              class="b-rad-16"
            >
              Продолжить
            </button>
            <button
              i18n="@@t-13"
              *ngIf="loading && !bookedId.errors?.['required'] && !bookedId.errors?.['minlength']"
              mat-raised-button
              disabled
              color="primary"
              class="b-rad-16"
            >
              Продолжить
            </button>
            <button
              i18n="@@t-14"
              *ngIf="!loading && !bookedId.errors?.['required'] && !bookedId.errors?.['minlength']"
              mat-raised-button
              color="primary"
              class="b-rad-16"
              (click)="checkForBooked()"
            >
              Продолжить
            </button>
          </div>

          <div *ngIf="state === 'specifyByPhone'">
            <div i18n="@@t-45" class="subtitle">
              Пожалуйста, уточните на кого была оформлена комната.
            </div>
            <!-- <label for="name" class="f-w-500">Enter Your ID</label> -->
            <div class="confirm-method inputs__wrapper">
              <button i18n="@@t-8" mat-button color="primary" class="b-rad-16" (click)="back()">
                ‹ Вернуться
              </button>
              <mat-form-field appearance="outline" class="w-100 custom-input">
                <input
                  i18n-placeholder="@@t-43"
                  matInput
                  [formControl]="phone"
                  [(ngModel)]="Phone"
                  placeholder="Номер телефона"
                />
                <mat-error i18n="@@t-36" *ngIf="phone.errors?.['required']">
                  Номер телефона обязателен
                </mat-error>
                <mat-error i18n="@@t-37" *ngIf="phone.errors?.['pattern']">
                  Пожалуйста, введите корректный формат номера телефона
                </mat-error>
                <mat-error i18n="@@t-44" *ngIf="phone.errors?.['incorrect-specify']">
                  По указанному номеру телефона комнаты не найдено
                </mat-error>
              </mat-form-field>
              <div *ngIf="loading" class="spinner__wrapper">
                <mat-spinner [diameter]="48"></mat-spinner>
              </div>
            </div>
            <span class="error-text" *ngIf="errors.init">
              {{ errors.init }}
            </span>
            <button
              i18n="@@t-12"
              *ngIf="phone.errors?.['required'] || phone.errors?.['pattern'] || phone.errors?.['incorrect-specify']"
              mat-raised-button
              disabled
              class="b-rad-16"
            >
              Продолжить
            </button>
            <button
              i18n="@@t-13"
              *ngIf="loading && !phone.errors?.['required'] && !phone.errors?.['pattern'] && !phone.errors?.['incorrect-specify']"
              mat-raised-button
              disabled
              color="primary"
              class="b-rad-16"
            >
              Продолжить
            </button>
            <button
              i18n="@@t-14"
              *ngIf="!loading && !phone.errors?.['required'] && !phone.errors?.['pattern'] && !phone.errors?.['incorrect-specify']"
              mat-raised-button
              color="primary"
              class="b-rad-16"
              (click)="checkForSpecifiedPhone()"
            >
              Продолжить
            </button>
          </div>

          <div *ngIf="state === 'specifyByRoom' || state === 'specifyByRoomAfterFull'">
            <div i18n="@@t-46" class="subtitle">
              Пожалуйста, уточните комнату бронирования.
            </div>
            <div class="confirm-method inputs__wrapper">
              <button i18n="@@t-8" mat-button color="primary" class="b-rad-16" (click)="back()">
                ‹ Вернуться
              </button>
              <mat-form-field appearance="outline" class="w-100 custom-input">
                <mat-select [(ngModel)]="room" (click)="clickToChooseRoom()">
                  <mat-option *ngFor="let room of rooms;" [value]="room._id">{{room.firstName}} {{room.lastName}}, {{room.booking?.dateStart | date : 'MM/dd/yy'}} - {{room.booking?.dateEnd | date : 'MM/dd/yy'}}</mat-option>
                </mat-select>
              </mat-form-field>
              <div *ngIf="loading" class="spinner__wrapper">
                <mat-spinner [diameter]="48"></mat-spinner>
              </div>
            </div>
            <span class="error-text" *ngIf="errors.generate">
              {{ errors.generate }}
            </span>
            <span class="error-text" *ngIf="errors.init">
              {{ errors.init }}
            </span>
            <button
              i18n="@@t-13"
              mat-raised-button
              [disabled]="loading || !room || !selectedRoomFlag"
              color="primary"
              class="b-rad-16"
              (click)="checkForSpecifiedRoom()"
            >
              Продолжить
            </button>
          </div>

          <div *ngIf="state === 'byName'">
            <div i18n="@@t-38" class="subtitle">
              Чтобы подтвердить бронирование, вам необходимо ввести Фамилию и Имя заселяющегося и
              следовать информации на экране.
            </div>
            <!-- <label for="name" class="f-w-500">Enter Your ID</label> -->
            <div class="confirm-method inputs__wrapper">
              <button i18n="@@t-8" mat-button color="primary" class="b-rad-16" (click)="back()">
                ‹ Вернуться
              </button>
              <mat-form-field appearance="outline" class="w-100 custom-input">
                <input
                  i18n-placeholder="@@t-28"
                  matInput
                  [formControl]="lastName"
                  required
                  [(ngModel)]="LastName"
                  placeholder="Фамилия"
                  (change)="onValidateNames($event, 'lastName')"
                />
                <mat-error i18n="@@t-29" *ngIf="lastName.errors?.['required']"
                  >Фамилия необходима</mat-error
                >
                <mat-error i18n="@@t-30" *ngIf="lastName.errors?.['minlength']"
                  >Фамилия должна иметь минимум 3 символа</mat-error
                >
                <mat-error i18n="@@t-39" *ngIf="lastName.errors?.['incorrect']">
                  По указанным имени и фамилии ничего не найдено
                </mat-error>
              </mat-form-field>
              <mat-form-field appearance="outline" class="w-100 custom-input">
                <input
                  i18n-placeholder="@@t-31"
                  matInput
                  [formControl]="firstName"
                  required
                  [(ngModel)]="FirstName"
                  placeholder="Имя"
                  (change)="onValidateNames($event, 'firstName', i)"
                />
                <mat-error i18n="@@t-32" *ngIf="firstName.errors?.['required']"
                  >Имя обязательно</mat-error
                >
                <mat-error i18n="@@t-33" *ngIf="firstName.errors?.['minlength']"
                  >Имя должно иметь минимум 3 символа</mat-error
                >
                <mat-error i18n="@@t-39" *ngIf="firstName.errors?.['incorrect']">
                  По указанным имени и фамилии ничего не найдено
                </mat-error>
              </mat-form-field>
              <div *ngIf="loading" class="spinner__wrapper">
                <mat-spinner [diameter]="48"></mat-spinner>
              </div>
            </div>
            <span class="error-text" *ngIf="errors.init">
              {{ errors.init }}
            </span>
            <button
              i18n="@@t-12"
              *ngIf="
                firstName.errors?.['required'] ||
                firstName.errors?.['minlength'] ||
                lastName.errors?.['required'] ||
                lastName.errors?.['minlength']
              "
              mat-raised-button
              disabled
              class="b-rad-16"
            >
              Продолжить
            </button>
            <button
              i18n="@@t-13"
              *ngIf="
                loading &&
                !firstName.errors?.['required'] &&
                !firstName.errors?.['minlength'] &&
                !lastName.errors?.['required'] &&
                !lastName.errors?.['minlength']
              "
              mat-raised-button
              disabled
              color="primary"
              class="b-rad-16"
            >
              Продолжить
            </button>
            <button
              i18n="@@t-14"
              *ngIf="
                !loading &&
                !firstName.errors?.['required'] &&
                !firstName.errors?.['minlength'] &&
                !lastName.errors?.['required'] &&
                !lastName.errors?.['minlength']
              "
              mat-raised-button
              color="primary"
              class="b-rad-16"
              (click)="checkForBooked()"
            >
              Продолжить
            </button>
          </div>

          <div *ngIf="state === 'byPhone'">
            <div i18n="@@t-34" class="subtitle">
              Чтобы подтвердить бронирование, вам необходимо ввести номер ID бронирования или
              заполнить следующие поля Фамилия, Имя или номер телефона.
            </div>
            <!-- <label for="name" class="f-w-500">Enter Your ID</label> -->
            <div class="confirm-method inputs__wrapper">
              <button i18n="@@t-8" mat-button color="primary" class="b-rad-16" (click)="back()">
                ‹ Вернуться
              </button>
              <mat-form-field appearance="outline" class="w-100 custom-input">
                <input
                  i18n-placeholder="@@t-35"
                  matInput
                  [formControl]="phone"
                  required
                  [(ngModel)]="Phone"
                  placeholder="Номер телефона"
                  (change)="onValidateNumber($event)"
                />
                <mat-error i18n="@@t-36" *ngIf="phone.errors?.['required']"
                  >Номер телефона обязателен</mat-error
                >
                <mat-error i18n="@@t-37" *ngIf="phone.errors?.['pattern']"
                  >Пожалуйста, введите корректный формат номера телефона</mat-error
                >
                <mat-error i18n="@@t-40" *ngIf="phone.errors?.['incorrect']">
                  По указанному номеру телефона ничего не найдено
                </mat-error>
              </mat-form-field>
              <div *ngIf="loading" class="spinner__wrapper">
                <mat-spinner [diameter]="48"></mat-spinner>
              </div>
            </div>
            <span class="error-text" *ngIf="errors.init">
              {{ errors.init }}
            </span>
            <button
              i18n="@@t-12"
              *ngIf="phone.errors?.['required'] || phone.errors?.['pattern']"
              mat-raised-button
              disabled
              class="b-rad-16"
            >
              Продолжить
            </button>
            <button
              i18n="@@t-13"
              *ngIf="loading && !phone.errors?.['required'] && !phone.errors?.['pattern']"
              mat-raised-button
              disabled
              color="primary"
              class="b-rad-16"
            >
              Продолжить
            </button>
            <button
              i18n="@@t-14"
              *ngIf="!loading && !phone.errors?.['required'] && !phone.errors?.['pattern']"
              mat-raised-button
              color="primary"
              class="b-rad-16"
              (click)="checkForBooked()"
            >
              Продолжить
            </button>
          </div>

          <div *ngIf="state === 'bookedIdConfirm'">
            <div i18n="@@t-48" class="subtitle">
              Подтвердите бронирование.
            </div>
            <!-- <label for="name" class="f-w-500">Enter Your ID</label> -->
            <div
              class="confirm-method inputs__wrapper"
              [ngClass]="{ 
                'booked-confirm': state === 'bookedIdConfirm'
              }"
            >
              <button i18n="@@t-16" mat-button color="primary" class="b-rad-16" (click)="back()"
                [ngClass]="{ 
                  'hidden': prevState === 'specifyByRoom' || prevState === 'specifyByPhone' || prevState === 'specifyByRoomAfterFull'
                }"
              >
                ‹ Вернуться
              </button>
              <mat-form-field appearance="outline" class="w-100 custom-input">
                <input matInput readonly [(ngModel)]="BookedId" />
              </mat-form-field>
              <div class="check-in-out">
                <div>
                  <label i18n="@@t-17" for="name">Check In</label>
                  <mat-form-field appearance="outline" class="w-100 custom-input">
                    <input matInput readonly [(ngModel)]="CheckIn" />
                  </mat-form-field>
                </div>
                <div class="check-in-out-divider">
                  <div>-</div>
                </div>
                <div>
                  <label i18n="@@t-18" for="name">Check Out</label>
                  <mat-form-field appearance="outline" class="w-100 custom-input">
                    <input matInput readonly required [(ngModel)]="CheckOut" />
                  </mat-form-field>
                </div>
              </div>
              <mat-form-field appearance="outline" class="w-100 custom-input">
                <input
                  matInput
                  readonly
                  [(ngModel)]="LastName"
                  i18n-placeholder="@@t-42"
                  placeholder="Нет данных"
                />
              </mat-form-field>
              <mat-form-field appearance="outline" class="w-100 custom-input">
                <input
                  matInput
                  readonly
                  [(ngModel)]="FirstName"
                  i18n-placeholder="@@t-42"
                  placeholder="Нет данных"
                />
              </mat-form-field>
              <mat-form-field appearance="outline" class="w-100 custom-input">
                <input
                  matInput
                  readonly
                  [(ngModel)]="Phone"
                  i18n-placeholder="@@t-42"
                  placeholder="Нет данных"
                />
              </mat-form-field>
              <div>
                <mat-checkbox color="primary" checked="true" (click)="changeValue(checked)" [disabled]="loading">
                  <span i18n="@@t-19" class="terms"
                    >Продолжая регистрацию, я соглашаюсь
                    <a href="https://google.com" target="_blank" rel="noopener noreferrer"
                      >с правилами использования платформы и обработки персональных данных</a
                    >, а также
                    <a href="https://google.com" target="_blank" rel="noopener noreferrer"
                      >публичной офертой</a
                    ></span
                  >
                </mat-checkbox>
              </div>
            </div>
            <span class="error-text" *ngIf="errors.init">
              {{ errors.init }}
            </span>
            <span class="error-text" *ngIf="errors.generate">
              {{ errors.generate }}
            </span>
            <button
              i18n="@@t-23"
              mat-raised-button
              color="primary"
              class="b-rad-16"
              [disabled]="!checked || loading"
              (click)="toConfirmBooked()"
            >
              Подтвердить
            </button>
          </div>

          <div *ngIf="state === 'bookedConfirmed'">
            <div i18n="@@t-20" class="subtitle">
              Ваше бронирование успешно подтверждено. Детали бронирования указаны ниже
            </div>
            <!-- <label for="name" class="f-w-500">Enter Your ID</label> -->
            <div class="confirm-method inputs__wrapper booked-confirmed">
              <div class="check-in-out">
                <div>
                  <label i18n="@@t-21" for="name">Check In</label>
                  <mat-form-field appearance="outline" class="w-100 custom-input">
                    <input matInput readonly [(ngModel)]="CheckIn" />
                  </mat-form-field>
                </div>
                <div class="check-in-out-divider">
                  <div>-</div>
                </div>
                <div>
                  <label i18n="@@t-22" for="name">Check Out</label>
                  <mat-form-field appearance="outline" class="w-100 custom-input">
                    <input matInput readonly required [(ngModel)]="CheckOut" />
                  </mat-form-field>
                </div>
              </div>
              <div class="code-link-wrapper">
                <div class="code-link code">
                  <div class="left">
                    <span>{{ codeLink.code }}</span>
                  </div>
                  <div class="right code">
                    <span i18n="@@t-24">Код от замка</span>
                  </div>
                </div>
                <div class="code-link link">
                  <div class="left">
                    <svg
                      viewBox="0 0 29 20"
                      preserveAspectRatio="xMidYMid meet"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g>
                        <path
                          d="M27.9727 3.12324C27.6435 1.89323 26.6768 0.926623 25.4468 0.597366C23.2197 2.24288e-07 14.285 0 14.285 0C14.285 0 5.35042 2.24288e-07 3.12323 0.597366C1.89323 0.926623 0.926623 1.89323 0.597366 3.12324C2.24288e-07 5.35042 0 10 0 10C0 10 2.24288e-07 14.6496 0.597366 16.8768C0.926623 18.1068 1.89323 19.0734 3.12323 19.4026C5.35042 20 14.285 20 14.285 20C14.285 20 23.2197 20 25.4468 19.4026C26.6768 19.0734 27.6435 18.1068 27.9727 16.8768C28.5701 14.6496 28.5701 10 28.5701 10C28.5701 10 28.5677 5.35042 27.9727 3.12324Z"
                          fill="#FF0000"
                        ></path>
                        <path
                          d="M11.4253 14.2854L18.8477 10.0004L11.4253 5.71533V14.2854Z"
                          fill="white"
                        ></path>
                      </g>
                    </svg>
                  </div>
                  <div class="right link">
                    <span
                      ><a
                        target="_blank"
                        [attr.href]="codeLink.link ? codeLink.link : null"
                        i18n="@@t-25"
                        >Обучающие видео, как пройти к своей комнате</a
                      ></span
                    >
                  </div>
                </div>
              </div>
            </div>
            <button
              style="margin-bottom: 24px"
              i18n="@@t-26"
              mat-raised-button
              disabled
              color="primary"
              class="b-rad-16"
              (click)="toSendMessage()"
            >
              Отправить на телефон
            </button>
            <button
              i18n="@@t-41"
              mat-raised-button
              color="primary"
              class="b-rad-16"
              (click)="toInitialState()"
            >
              Вернуться на главную
            </button>
          </div>

          <div class="locales">
            <a href="/de/check">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 336" fill="none">
                <path
                  d="M512 112.093H0V9.104C0 4.229 3.953 0.276001 8.828 0.276001H503.173C508.048 0.276001 512.001 4.229 512.001 9.104L512 112.093Z"
                  fill="#464655"
                />
                <path
                  d="M503.172 335.725H8.828C3.953 335.725 0 331.772 0 326.897V223.909H512V326.897C512 331.773 508.047 335.725 503.172 335.725Z"
                  fill="#FFE15A"
                />
                <path d="M512 112.091H0V223.901H512V112.091Z" fill="#FF4B55" />
              </svg>
            </a>
            <a href="/ru/check">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 336" fill="none">
                <path
                  d="M512 112.093H0V9.104C0 4.229 3.953 0.276001 8.828 0.276001H503.173C508.048 0.276001 512.001 4.229 512.001 9.104L512 112.093Z"
                  fill="#F5F5F5"
                />
                <path
                  d="M503.172 335.719H8.828C3.953 335.719 0 331.766 0 326.891V223.903H512V326.891C512 331.767 508.047 335.719 503.172 335.719Z"
                  fill="#FF4B55"
                />
                <path d="M512 112.093H0V223.903H512V112.093Z" fill="#41479B" />
              </svg>
            </a>
          </div>
        </div>
      </app-card>
    </div>
  </div>
</div>
